import { message } from "antd"
import { AxiosRequestConfig } from "axios"
import { HttpClient } from "../app/api/HttpClient"
import { API_PREFIX_POST_PATH, API_PREFIX_TAG_PATH } from "../constants/prefix-path-api"
import { AttributesCategory } from "../lib/config/types"
import { FilterSearchParams } from "../lib/external-components"

export const fetchPostAll = async (filters = {}, locale?: string) => {
  const params: FilterSearchParams = {
    pagination: {
      pageSize: "100",
    },
    populate: "*",
    filters: {},
    sort: "createdAt:desc",
    publicationState: "live",
    locale: locale || localStorage.getItem("language") || "vi",
  }
  return await HttpClient.get(`${API_PREFIX_POST_PATH}`, { params })
}

export const fetchPostByCategories = async (
  categoriesId: string[],
  paginationParams?: { page?: string; pageSize?: string },
  locale?: string,
) => {
  const params: FilterSearchParams = {
    populate: "*",
    sort: "createdAt:desc",
    publicationState: "live",
    filters: {
      categories: {
        // @ts-ignore
        id: {
          $in: categoriesId,
        },
      },
    },
    pagination: {
      pageSize: paginationParams?.pageSize || "10",
      ...(paginationParams?.page && { page: paginationParams.page }),
    },
    locale: locale || localStorage.getItem("language") || "vi",
  }

  try {
    const response = await HttpClient.get(`${API_PREFIX_POST_PATH}`, { params })

    const modifiedResponse = response.data.map((post: any) => ({
      ...post,
      status: post.attributes.publishedAt ? "published" : "draft",
      publishedAt: post.attributes.publishedAt,
    }))

    return {
      data: modifiedResponse,
      meta: response.meta,
    }
  } catch (error) {
    message.error("Không thể lấy bài viết. Vui lòng thử lại.")
  }
}

export const fetchPosts = async (searchTerms: { [key: string]: string } = {}, locale?: string) => {
  const params: FilterSearchParams = {
    populate: "*",
    sort: "createdAt:desc",
    publicationState: "preview",
    filters: {},
    pagination: {
      pageSize: "100",
    },
    locale: locale || localStorage.getItem("language") || "vi",
  }
  const excludedKeys = ["current", "pageSize", "start", "limit", "total", "page"]

  Object.keys(searchTerms).forEach(key => {
    const value = searchTerms[key]

    if (key === "publicationState") {
      const convertParamStatusPost = value === "draft" || value === "all" ? "preview" : "live"
      params.publicationState = convertParamStatusPost

      if (value === "draft") {
        params.filters.publishedAt = { $null: true }
      } else {
        delete params.filters.publishedAt
      }
    } else if (key === "locale") {
      params.locale = value
    } else if (!excludedKeys.includes(key)) {
      if (key === "category") {
        params.filters.category = { $eq: value }
      } else {
        if (value) {
          params.filters[key] = { $containsi: value }
        }
      }
    } else if (value) {
      params.pagination = {
        ...params.pagination,
        [key]: value,
      }
    }
  })

  try {
    const response = await HttpClient.get(`${API_PREFIX_POST_PATH}`, { params })
    const modifiedResponse = response.data.map((post: any) => ({
      ...post,
      status: post.attributes.publishedAt ? "published" : "draft",
      publishedAt: post.attributes.publishedAt,
    }))

    return {
      data: modifiedResponse,
      meta: response.meta,
    }
  } catch (error) {
    message.error("Không thể lấy bài viết. Vui lòng thử lại.")
  }
}

export const fetchPostId = async (id: number, locale?: string) => {
  const localeParam = locale || localStorage.getItem("language") || "vi"
  const response = await HttpClient.get(`${API_PREFIX_POST_PATH}/${id}?populate=*&locale=${localeParam}`)
  return response.data
}

export const deletePost = async (id: number) => {
  return await HttpClient.delete(`${API_PREFIX_POST_PATH}/${id}`)
}
export const updatePost = async (id: number, data: any) => {
  return await HttpClient.put(`${API_PREFIX_POST_PATH}/${id}`, data)
}
export const addPost = async (data: any) => {
  return await HttpClient.post(`${API_PREFIX_POST_PATH}`, data)
}

export const fetchCategories = async () => {
  return await HttpClient.get(`/api/cateogries`)
}

export const fetchTags = async () => {
  return await HttpClient.get(`/api/tags`)
}

export const createTag = async (data: AttributesCategory) => {
  return await HttpClient.post(`${API_PREFIX_TAG_PATH}`, { data })
}

export const checkSlug = async (slug: string, locale?: string) => {
  const params: AxiosRequestConfig["params"] = {
    filters: {
      slug: { $eq: slug },
    },
    publicationState: "preview",
    locale: locale || localStorage.getItem("language") || "vi",
  }
  return await HttpClient.get(`${API_PREFIX_POST_PATH}`, { params })
}
